<template>
  <h1>hi</h1>
</template>

<script>
export default {
  name: 'ReportSegment',
}
</script>

<style scoped>

</style>
